export const nodeTypes = () => {
  return ({
    array: {
      'text': 'New text item',
      'keyPair': { [Date.now()]: 'key value' },
      'array': ['new array item']
    },
    object: {
      'keyPair': { [Date.now()]: 'key value' },
      'array': { [Date.now()]: ['New array item'] },
    }
  })
}

export const tempData = [
  'new array item',
  { 'click': 'header to add more' },
  ['Text item in array']
]

